import { datadogRum } from '@datadog/browser-rum';
import { CoreApplicationContext } from '@eventbrite/context-gen';
import { EBEnvs } from '@eventbrite/feature-detection';
import { initializeRealUserMonitoring } from '@eventbrite/real-user-monitoring';
import { configureStore } from '@eventbrite/redux-configure-store';
import { middleware as analyticsMiddleware } from '@eventbrite/site-analytics';
import React from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { ConfirmationOverlay } from '../../components/ConfirmationOverlay';
import { ConsumerHeader } from '../../components/ConsumerHeader';
import { OverlayProvider } from '../../context/Overlay';
import reducer from '../../redux/reducers';
import { getInitialData } from '../../redux/reducers/utils';
import { isProd } from '../../utils/http';
import '../app.scss';
import { BasePage } from '../base';
import { SearchBaseContainer } from './containers';

interface SearchPageProps {
    env: CoreApplicationContext['env'];
    app_version?: string;
    app_name: string;
    user: {
        isAuthenticated?: boolean;
        publicId?: string;
        email?: string;
        isStaff?: boolean;
    };
    request: { session_id: string };
}

export class SearchPage extends React.Component<SearchPageProps> {
    private _store: any;
    constructor(props: Readonly<SearchPageProps>) {
        super(props);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer,
            initialState: getInitialData(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });
    }

    componentDidMount() {
        const { env } = this.props;

        if (isProd({ env })) {
            initializeRealUserMonitoring({
                sampleRate: 0.4,
                version: this.props.app_version,
                service: this.props.app_name,
                env: EBEnvs.PROD,
            });

            datadogRum.onReady(() =>
                datadogRum.addRumGlobalContext('view.sub_app', 'search'),
            );
        }
    }

    render() {
        return (
            <Provider store={this._store}>
                <OverlayProvider>
                    <BasePage
                        {...this.props}
                        isSearchPage={true}
                        structureHeader={ConsumerHeader}
                        removeOverflowSettings={true}
                    >
                        <ConfirmationOverlay />
                        <div className="feed-search-page">
                            <SearchBaseContainer {...this.props} />
                        </div>
                    </BasePage>
                </OverlayProvider>
            </Provider>
        );
    }
}

export default SearchPage;
